$(document).bind('click',function (e) {
  //节点office 个人信息下拉
  if($(e.target).parents('.personal-menu').length <= 0) {
    $(e.target).parents('li.personal-menu').find('.personal-menu-ul').slideUp(500);
    $('.arrow').removeClass('open');
  }
  // 是否关闭多项IC时的下拉列表
  if($(e.target).parents('.ic-control').length <= 0){
    $('.other-ics').slideUp(300);
  }
  //是否关闭详情页用户信息的更多信息
  if(($(e.target).parents('.utm-details-content-more-info-header').length > 0)){
    $(e.target).parents('.utm-details-content-more-info').find('i.arrow').toggleClass('open');
    $(e.target).parents('.utm-details-content-more-info').children('.utm-controls-more-info').slideToggle()
  }
  // 关闭快速注册搜索面板
  if(!(e.target.className.indexOf('fast-search-input') > -1 || $(e.target).parents('.result-list-panel').length > 0 || e.target.className.indexOf('quick-search-btn') > -1 ||  $(e.target).parents('.quick-search-btn').length > 0)){
    $('.result-list-panel').slideUp(300);
  }
  /*联动输入框和文本输入框获取焦点的样式*/
  if($(e.target).parents('.utm-linkage').length > 0){
    $('.utm-linkage-focus').removeClass('utm-linkage-focus');
    $(e.target).parents('.utm-linkage').addClass('utm-linkage-focus')
  }else {
    $('.utm-linkage-focus').removeClass('utm-linkage-focus');
  }
  if($(e.target).parents('.utm-select-group').length > 0){
    $('.utm-select-group-focus').removeClass('utm-select-group-focus');
    $(e.target).parents('.utm-select-group').addClass('utm-select-group-focus')
  }else {
    $('.utm-select-group-focus').removeClass('utm-select-group-focus');
  }
  // 关闭tab选额列表
  if(!(((e.target.className.indexOf('tag-checked-box') > -1) || $(e.target).parents('.utm-multiple-check').length > 0))){
    $('.multiple-check-panel').slideUp(300);
    $('.utm-multiple-check').removeClass('focus-box');
  }
  // 是否关闭左侧栏更多操作列表
  if(e.target.className.indexOf('utm-item-operation-icon') <= -1){
    $('.utm-left-more-operation').css({
      'left':'-200%', 'botton':'unset', 'top':'-200%'
    });
  }
  // 关闭更多tab选项列表
  if(!(((e.target.className.indexOf('more-tab-item') > -1) || $(e.target).parents('.more-tab-item').length > 0)) || (e.target.className.indexOf('other-tab-item') > -1)){
    $('.other-tab-box').slideUp(300);
    $('.more-tab-arrow').css({transform: 'rotate(0deg)'});
  }
  // 关闭事件配置搜索用户列表
  if($(e.target).parents('.add-receiver-btn').length === 0){
    $('.receiver-panel').slideUp(300);
  }
  // 关闭人脸上传方式
  if(e.target.className.indexOf('add-user-photo-bg') <= -1){
    $('.upload-face-methods').slideUp(300);
    $('.pro-upload-face-methods').slideUp(300);
    $('.upload-face-way').slideUp(300);
    $('.pro-upload-face-method').slideUp(300);
  }
  // 关闭tag选泽
  if(!((e.target.className.indexOf('tag-check-btn') > -1) || $(e.target).parents('.tag-check-btn').length > 0)){
    $('.utm-tag-panel').slideUp(300);
  }
  // 关闭视频通话选择设备的弹层
  if(!((e.target.className.indexOf('system-device-box') > -1) || $(e.target).parents('.system-device-box').length > 0)){
    $('#call_up .system-device-box .system-device-arrow').removeClass('open');
    $('#call_up .system-device-box .system-device-panel').slideUp();
  }
});
import realTimeMessages from '../commonComponents/realTimeMessage.vue';
import messageCenter from '../commonComponents/messageCenter.vue';
import notification from '../commonComponents/dynamicNotification.vue';
import messageFoward from '../commonComponents/messageFoward.vue';
import messageDetailModal from '../commonComponents/messageDetailModal.vue';
import modifyPsd from '../commonComponents/modifyPassword.vue';
import fastRegistration from '../fastRegistration/fastRegistration.vue';
import generateReport from '../commonComponents/reportGenerateComponent.vue';
import asynchronousUpload from './asynchronousUpload.vue';
import sendEmail from '../commonComponents/forwardEmail.vue';
import utmTeleport from '../commonComponents/utmTeleport.vue';
import downloadCenter from '../downloadCenters/downloadCenter.vue'

import Vue from 'vue'
let _this;
export default {
  name: "nav-top",
  components:{
    realTimeMessages,
    messageCenter,
    notification,
    messageFoward,
    modifyPsd,
    fastRegistration,
    generateReport,
    asynchronousUpload,
    sendEmail,
    utmTeleport,
    downloadCenter,
    messageDetailModal
  },
  data(){
    return {
      roleList:[],
      /*修改用户信息*/
      adminInfo:{
        userName:"",
        email:"",
        mobile:"",
        password:""
      },
      adminInfoModal:false,
      changePwdUserId:"",
      /*其它modal*/
      exitModal:false, //退出登录
      loginModal:false,  //提示重新登录
      asynchronousCount:0,
      notificationTime:null,
      specificNodeJump:{
        '/editStaff':'staffList',
        '/editVisitor':'visitorList',
        '/editVendor':'vendorList',
        '/editTenant':'tenantList',
      },/*特定的节点跳转*/
      isHasDownLoading:false,
      downloadingTimer:'',
    }
  },
  mounted(){
    _this = this;
    _this.init();
    //实时刷新异步上传文件数量

    _this.$refs.asynchronous.getTotal((num) => {
      _this.asynchronousCount = num;
    });
    _this.$root.getUnreadMessage();
    if( _this.$root.adminInfo.permissionCodes.indexOf('M_RecurringReport') > -1
    ||  _this.$root.adminInfo.permissionCodes.indexOf('M_ManuallyGenerated') > -1
    ||  _this.$root.adminInfo.permissionCodes.indexOf('M_VideoDownloadCenter') > -1
    ){
      _this.getReportAmount()
    }
   
  },
  beforeDestroy(){
    clearTimeout(_this.notificationTime);
    clearTimeout(_this.downloadingTimer);
  },
  methods:{
    getReportAmount:function(callback){
      clearTimeout(this.downloadingTimer);
      _this.$ajax.get('GenerateReport/GetGeneratingCount',{headers: {noLoading: true}, codes: ['M_RecurringReport','M_ManuallyGenerated','M_VideoDownloadCenter'] }).then(res=>{
        if(res.data.success){
          _this.isHasDownLoading = (res.data.data > 0);
            _this.downloadingTimer = setTimeout(function () {
              _this.getReportAmount();
            },5000);
        }else{
            _this.downloadingTimer = setTimeout(function () {
              _this.getReportAmount();
            },5000);
        }
      }).catch(err =>{
        if(_this.navTopIsShow){
          _this.downloadingTimer = setTimeout(function () {
            _this.getReportAmount();
          },_this.$root.reconnectTime);
        }
      })
    },
    init(){
      $(document).bind('click', function (e) {
        if (!(e.target.className === 'personal-menu-btn' || $(e.target).parent('.personal-menu-btn').length > 0
          || e.target.className === 'file-transfer-wapper' || $(e.target).parents('.file-transfer-wapper').length > 0)) {
          $('.personal-menu-ul').fadeOut();
          $(e.target).parents('li.personal-menu').find('.arrow').removeClass('open');
        }
      })
    },
    /*收缩菜单*/
    shrinkMenu: () => {
      _this.$root.menu.shrink = _this.$root.menu.shrink + 1;
      if (_this.$root.menu.shrink == 1) {
        localStorage.setItem("shrinkStr", 'closed');
      }
      if (_this.$root.menu.shrink == 2) {
        localStorage.setItem("shrinkStr", 'retract');
      }
      if (_this.$root.menu.shrink == 3) {
        _this.$root.menu.shrink = 0;
        localStorage.setItem("shrinkStr", 'open');
      }
      let timer = setTimeout(function () { /*动画结束后获取内容宽度*/
        clearTimeout(timer);
        _this.$root.contentWidth = $('#page-content')[0].clientWidth;
      },300)
    },
    //跳转回home
    returnHome: () => {
      _this.$router.push({
        path: "/home"
      });
      _this.$root.menu.navTitle = 'M_Dashboard';
      _this.$root.menu.childTitle = 'M_Dashboard';
      _this.$root.menu.secondChildTitle = '';
      localStorage.setItem("menuTitle", type);
      localStorage.setItem("childMenuTitle", type);
      localStorage.setItem("secondChildTitle", '');
    },
    //打开管理员菜单
    openPersonalMenu: function (e,type) {
      if(this.$root.navNodes.length < 2 && type == 1){
        return false;
      }
      if(this.$root.navOffices.length == 1 && type == 2){
        return false;
      }
      e.stopPropagation();
      $(e.target).parents('li.personal-menu').find('.personal-menu-ul').slideToggle();
      //排除点击异步上传的内容关闭弹窗 $(e.target).parents('.admin-btn').find('ul.current-login-user').slideToggle();
      $(e.target).parents('li.personal-menu').siblings().find('.personal-menu-ul').slideUp();
      $(e.target).parents('li.personal-menu').find('.arrow').toggleClass('open');
    },
    //打开管理员信息
    openUserInfoDetail:function(){
      this.$validator.errors.clear('adminInfo');
      this.getAllRole();
      this.$ajax.get( 'Accounts/GetPersonalInfo?id=' + this.$root.adminInfo.id,{ baseURL: window.g.VERIFICATION_ROOT}).then(function (res) {
        if (res.data.success && res.data.data) {
          _this.adminInfoModal = true;
          _this.adminInfo = res.data.data;
        } else if(res.data.message){
          _this.messageNotice("error",res.data.message);
        }
      })
    },
    //获取登录用户角色列表
    getAllRole: function () {
      this.$ajax.post('Roles/PagingOption',{  enabledPaging: false, page: 1, perPage: 100},{ baseURL: window.g.VERIFICATION_ROOT }).then(function (res) {
        if (res.data.success) {
          _this.roleList = res.data.data.items;
        } else {
          _this.roleList = [];
        }
      })
    },
    //保存管理员信息
    changeAdminInfo:function(){
      this.$validator.validateAll('adminInfo').then((result) => {
        if (result) {
          let url = 'Accounts/Edit';
          let params = JSON.parse(JSON.stringify(this.adminInfo));
          this.$ajax.put(url, params,{ baseURL: window.g.VERIFICATION_ROOT }).then(function (res) {
            if (res.data.success) {
              _this.messageNotice("success");
              _this.adminInfoModal = false;
            } else if(res.data.message){
              _this.messageNotice("error",res.data.message);
            }
          })
        }
      });
    },
    // 注销登录
    logOut:function () {
      _this.ApiService.logoutToken('access_token');
      _this.$router.push('/login');
      _this.ApiService.clearToken();
      sessionStorage.setItem('searchChart',[]);
      localStorage.removeItem('currentNodeAndOffice');
      _this.exitModal = false;
    },
    // 修改管理员密码
    changeAdminPwd:function (){
      eventBus.$emit('verifyUserPsd',_this.$root.adminInfo.id);
    },
    reLogin:function(){
      _this.$router.push({path:'/login'});
      _this.loginModal = false;
    },
    // 打开消息中心
    openMessageCenter:function(){
      _this.$refs.msgCenter.open();
    },
    // 打开动态通知
    openDyNotification:function(){
      _this.$refs.notice.open();
    },
    // 打开异步上传
    openFileTransfer:function(){
      _this.$refs.asynchronous.open();
    },
    //上传License
    uploadLicense:function(){
      _this.$router.push({path: '/uploadLicense'});
    },
    //改变节点
    changeNodes: function (data){
      // 改蜂窝缓存的数据
      let tileInfo = localStorage.getItem("currentNodeAndOffice")
      if(data.id && tileInfo){
        let temp = JSON.parse(tileInfo);
        temp.BuildingNodeId = data.id;
        temp.officeId = "";
        temp.name = "";
        temp.onLoad = true;
        localStorage.setItem('currentNodeAndOffice', JSON.stringify(temp))
      }
      _this.$root.curNodeInfo = JSON.parse(JSON.stringify(data));
      _this.ApiService.nodeId = _this.$root.curNodeInfo.id;
      localStorage.setItem('searchData', '');
      _this.$root.saveCurrentNode(data.id, ()=>{
        // 部分编辑界面中切换节点，会跳转到指定路由
        let router = this.specificNodeJump[this.$route.path];
        if(router){
          _this.$router.push(router);
        }else{
          _this.$router.go(0);
        }
      })
    },
    changeOffice:function(data){
      _this.$root.ischangeOffice = false;
      _this.$root.curOfficeInfo = JSON.parse(JSON.stringify(data));
      let timer = setTimeout(function () { /*动画结束后获取内容宽度*/
      clearTimeout(timer);
      _this.$root.ischangeOffice = true;
    },300)
    },
    //下载中心
    downloadCenter: function () {
      this.$refs.downloadCenter.openLoadCenter();
    },
  }
}



// WEBPACK FOOTER //
// ./src/admin/components/navTop/navTop.js